export const Table = ({options, classNames, children}) =>
{
  const styleRequest =
  {
    height: options?.heightRequest?.value ?? 'auto',
    minHeight: options?.heightRequest?.min ?? 'auto',
    maxHeight: options?.heightRequest?.max ?? 'auto',
  };
  return (
    <div style={styleRequest} className={['ui-table h-8 max-w-full overflow-auto', ...(classNames ?? [])].join(' ')}>{children}</div>
  );
};
